import { useEffect, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

export function ViewportSunLights({
  ambientIntensity,
  directionalIntensity,
  directionalColor,
  shadowMapSize,
  transitionSpeed = 6,
}) {
  const ambientRef = useRef(null);
  const directionalRef = useRef(null);
  const targetDirectionalColor = useRef(new THREE.Color(directionalColor));
  const targetAmbient = useRef(ambientIntensity);
  const targetDirectional = useRef(directionalIntensity);

  useEffect(() => {
    targetAmbient.current = ambientIntensity;
    targetDirectional.current = directionalIntensity;
    targetDirectionalColor.current.set(directionalColor);
  }, [ambientIntensity, directionalIntensity, directionalColor]);

  useFrame((state, delta) => {
    const alpha = 1 - Math.exp(-transitionSpeed * delta);
    let moved = 0;
    if (ambientRef.current) {
      const prev = ambientRef.current.intensity;
      ambientRef.current.intensity +=
        (targetAmbient.current - ambientRef.current.intensity) * alpha;
      moved += Math.abs(ambientRef.current.intensity - prev);
    }
    if (directionalRef.current) {
      const prevIntensity = directionalRef.current.intensity;
      const prevColor = directionalRef.current.color.clone();
      directionalRef.current.intensity +=
        (targetDirectional.current - directionalRef.current.intensity) * alpha;
      directionalRef.current.color.lerp(targetDirectionalColor.current, alpha);
      moved += Math.abs(directionalRef.current.intensity - prevIntensity);
      moved +=
        Math.abs(directionalRef.current.color.r - prevColor.r) +
        Math.abs(directionalRef.current.color.g - prevColor.g) +
        Math.abs(directionalRef.current.color.b - prevColor.b);
    }
    if (moved > 0.0002) state.invalidate();
  });

  return (
    <>
      <ambientLight ref={ambientRef} intensity={ambientIntensity} />
      <group name="sun" position={[0, 10, 100]} rotation={[-Math.PI / 2, 0, 0]}>
        <directionalLight
          ref={directionalRef}
          matrixAutoUpdate={false}
          intensity={directionalIntensity}
          color={directionalColor}
          shadow-mapSize-height={shadowMapSize}
          shadow-mapSize-width={shadowMapSize}
        />
      </group>
    </>
  );
}
